// extracted by mini-css-extract-plugin
export default {"row":"EventOfferFixedPriceSpecificTypes_row__lSLSi","wrapper":"EventOfferFixedPriceSpecificTypes_wrapper__Ge5SH","item":"EventOfferFixedPriceSpecificTypes_item__2pkJP"};